import * as React from "react";

export const enum RadioVariant {
  Check = "check",
  Times = "times",
}

export type RadioProps = {
  /**
   * If `true`, the component is disabled
   */
  disabled?: boolean;
  /**
   * If you want to use the Radio as a controlled component,
   * need to pass onchange function
   */
  checked?: boolean;
  /**
   * Event handler for change, required if you want to use the Radio as a controlled component
   */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * The value name of the Radio
   */
  name?: string;
  /**
   * Label of the Radio
   */
  children?: React.ReactNode;
  /**
   * Custom appearance of the Radio
   */
  variant?: "check" | "times";
  /**
   * Value of the Radio
   */
  value?: string | number;
} & React.InputHTMLAttributes<HTMLInputElement>;
